/**
 * rejectionReason: the reason an admin gives when rejecting a campaign is
 * shown to the issuer (campaign_details.rejection_reason), so a rejection
 * needs one that actually explains something.
 *
 * Mirrors the API, which refuses a rejection whose trimmed reason is shorter
 * than this with 400 { code: 'REJECTION_REASON_REQUIRED' } on both
 * update-campaign-byadmin (New Submissions) and admin/approve-admin-review
 * (Pending Edits). The server is the control; this keeps an obviously short
 * reason from ever becoming a request. Same shape as campaignIdentity.js's
 * MIN_REASON_LENGTH and wireReceiptUi.js's reversalReasonError.
 */

/** The API refuses a rejection reason shorter than this (after trimming). */
export const MIN_REJECTION_REASON_LENGTH = 20;

/** The refusal message for a rejection reason, or null when it is acceptable. */
export function rejectionReasonError(reason) {
  if (String(reason ?? "").trim().length >= MIN_REJECTION_REASON_LENGTH) return null;
  return `A reason of at least ${MIN_REJECTION_REASON_LENGTH} characters is required to reject. It is shown to the issuer.`;
}
